// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../GeneratePriceModal/GeneratePriceModal.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-details-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.payment-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  color: #3a445d;
}

.payment-amount {
  font-weight: 700;
  font-size: 18px;
}

.payment-status-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #e6f7f0;
  color: #00875a;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
}

.payment-status-chip img {
  height: 16px;
}

.confirm-btn {
  background-color: #00875a;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-btn:hover {
  background-color: #00694a;
}

@media (max-width: 600px) {
  .payment-details-body {
    gap: 10px;
  }
  .confirm-btn {
    padding: 8px 16px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/PaymentDetailsModal/PaymentDetailsModal.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["@import \"../GeneratePriceModal/GeneratePriceModal.css\";\n\n.payment-details-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.payment-info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 16px;\n  color: #3a445d;\n}\n\n.payment-amount {\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.payment-status-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #e6f7f0;\n  color: #00875a;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.payment-status-chip img {\n  height: 16px;\n}\n\n.confirm-btn {\n  background-color: #00875a;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.confirm-btn:hover {\n  background-color: #00694a;\n}\n\n@media (max-width: 600px) {\n  .payment-details-body {\n    gap: 10px;\n  }\n  .confirm-btn {\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
